import http from "./http";
import Service from "../Service";

/**
 * @type OrderService
 */
export default class OrderService extends Service {
    exportTxt(params) {
        return http.get("clients/orders/export-txt", {
            headers: this.getHeaders(),
            params,
            responseType: "blob",
        });
    }
}
